import type { IconProps } from './types';
import './icons.css';

export default function Close({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      className={`icon icon-close ${className || ''}`}
    >
      <path
        stroke="currentColor"
        d="m3.542 3.542 12.916 12.916M16.458 3.542 3.542 16.458"
      />
    </svg>
  );
}
